import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import DefaultLayout from "../../components/layout/DefaultLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  addNoteFromPreEnrolment,
  fetchPreEnrolsAction,
} from "../pre-enrolment/preEnrolmentAction";
import PreEnrolmentInfo from "../../components/pre-enrolment-info/PreEnrolmentInfo";
import { toast } from "react-toastify";
import { NoData } from "../../components/no-data/NoData";

const PreEnrolmentDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { _id } = useParams();
  const { user } = useSelector((state) => state.user);
  const [show, setShow] = useState(false);

  const noteRef = useRef("");
  const sendEmailRef = useRef("");
  const subjectRef = useRef("");

  // Fetch pre-enrolments on mount
  useEffect(() => {
    if (user?.branch) {
      const params = new URLSearchParams();
      params.set("branch", user.branch);
      dispatch(fetchPreEnrolsAction(params.toString()));
    }
  }, [dispatch, user?.branch]);

  const { preEnrolments } = useSelector((state) => state.preEnrol);
  const preEnrolment = preEnrolments.find((item) => item._id === _id);

  if (!preEnrolment?._id) {
    return <NoData />;
  }

  // Prepare URL params for note actions
  const params = new URLSearchParams();
  params.set("branch", user?.branch);
  const par = params.toString();

  const handleOnSubmit = () => {
    const sendEmailFromNote = sendEmailRef.current?.checked;
    const subject = subjectRef.current?.value;

    if (!noteRef.current?.value) {
      toast.warn("Please add some message");
      return;
    }

    const obj = {
      _id,
      message: noteRef.current.value,
      sendEmailFromNote,
      subject,
      email: preEnrolment.email,
      fName: preEnrolment.fName,
      params: par,
    };

    dispatch(addNoteFromPreEnrolment(obj));

    // Reset inputs
    noteRef.current.value = "";
    setShow(false);
  };

  return (
    <DefaultLayout>
      <Row>
        <Col>
          <Button
            variant="outline-secondary"
            onClick={() => navigate("/pre-enrolment")}
          >
            &lt; Back
          </Button>
        </Col>
      </Row>

      <PreEnrolmentInfo />

      <Container className="mt-5 courseInfo">
        <Row className="py-2">
          <Col md="12">
            <h5>Conversation History</h5>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <div className="message-history">
              {preEnrolment?.note?.length
                ? preEnrolment.note.map(
                    (msg, i) =>
                      msg.message && (
                        <div className="message-history-list" key={i}>
                          <div className="mb-1">
                            {msg.addedBy} -{" "}
                            <small>
                              {new Date(msg.addedAt).toLocaleString([], {
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                                hour12: true,
                                hour: "numeric",
                                minute: "numeric",
                              })}
                            </small>
                          </div>
                          <div className="lead-message">
                            {msg.message}
                            {msg.tag ? (
                              <span className="lead-message-tag">
                                <i className="fa-solid fa-circle-check text-success"></i>
                                <i>{msg.tag}</i>
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )
                  )
                : "No conversation history yet."}
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="reply-msg mt-5 mb-2">
              <Form.Group as={Col}>
                <Form.Label htmlFor="" style={{ color: "grey" }}>
                  Reply
                </Form.Label>
                <Form.Control
                  ref={noteRef}
                  as="textarea"
                  rows="3"
                  className="my-3"
                  placeholder="'Dear clientName' in the header and 'Dented Code info' in footer is automatically added. Please only add the main body text."
                />

                {show && (
                  <div className="d-flex align-items-center gap-2 mb-2">
                    Subject:{" "}
                    <Form.Control
                      type="text"
                      placeholder="Enter subject for email..."
                      ref={subjectRef}
                    />
                  </div>
                )}

                <div className="d-flex align-items-center gap-2 mb-3">
                  <Form.Check
                    ref={sendEmailRef}
                    onChange={(e) =>
                      e.target.checked ? setShow(true) : setShow(false)
                    }
                  />
                  <span>Send as email</span>
                </div>

                <Button onClick={handleOnSubmit} variant="primary">
                  Reply
                </Button>
              </Form.Group>
            </div>
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  );
};

export default PreEnrolmentDetails;
